import ApplicationAdapter from 'cio/adapters/application';
import DS from 'ember-data';
import { ModelRegistry } from 'ember-data/model';

export default class CampaignNoteAdapter extends ApplicationAdapter {
  buildURL(
    _modelName?: keyof ModelRegistry,
    id?: string,
    snapshot?: DS.Snapshot | any[] | null,
    requestType?: string,
    query?: Record<string, any>,
  ) {
    let base = this.pathForType('campaign');

    let campaignId: string | null = null;

    if (query?.campaign_id) {
      campaignId = query.campaign_id;
    } else if (snapshot instanceof DS.Snapshot && snapshot?.belongsTo('campaign')) {
      campaignId = snapshot.belongsTo('campaign')?.id ?? null;
    }

    let url = `${this.host}/${this.namespace}/${base}/${campaignId}/notes`;

    if (requestType === 'query' || requestType === 'createRecord') {
      return url;
    }

    if (requestType === 'findRecord' || requestType === 'updateRecord' || requestType === 'deleteRecord') {
      return `${url}/${id}`;
    }

    return url;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'campaign-note': CampaignNoteAdapter;
  }
}
